import { AccountEffects } from './account.effects';
import { TrackingEffects } from './tracking.effects';

export const effects = [TrackingEffects, AccountEffects];

export { TrackingEffects, AccountEffects };
